module.exports = __webpack_public_path__ + "img/titlePc23-safeimagekit.32590609.png";